import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  bcpDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './generate-full-report-dialog.controller';
import template from './generate-full-report-dialog.html';

// Validation
import assessmentGenerateFullReportMessagesTpl from '../messages/assessment.generate.full.report.messages.html';


class dialogService {
  getOptions($event, { assessment, settings }) {
    return {
      controller,
      controllerAs: 'fullReportDialogVM',
      locals: {
        assessment,
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.generateFullReportDialog', [
  ngCookies,
  bcpDataService,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
])
  .service('generateFullReportDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.generate.full.report.messages.html', assessmentGenerateFullReportMessagesTpl);
  })
  .name;
